/* Skarpast collection/search enhancements:
   - live in-grid product search
   - brand filter (products tagged with their collection handles, filtered in-place)
   - grid/list view toggle
   Loaded as an external asset so Horizon's AJAX re-render (sort/filter morph)
   doesn't re-execute it. Re-binds after updates. */
(function () {
  function state(scope) {
    if (!scope.__sk) scope.__sk = { q: '', brands: new Set(), empty: 'Inga produkter hittades.' };
    return scope.__sk;
  }

  function haystack(item) {
    var parts = [];
    var t = item.querySelector('.sk-card__title');
    var m = item.querySelector('.sk-card__meta');
    if (t) parts.push(t.textContent);
    if (m) parts.push(m.textContent);
    if (parts.length === 0) parts.push(item.textContent);
    return parts.join(' ').toLowerCase();
  }

  function itemBrands(item) {
    return (item.getAttribute('data-sk-brands') || '').toLowerCase().split(/\s+/).filter(Boolean);
  }

  function ensureEmptyEl(scope) {
    var el = scope.querySelector('.sk-grid-empty');
    if (!el) {
      el = document.createElement('p');
      el.className = 'sk-grid-empty';
      el.setAttribute('role', 'status');
      el.style.display = 'none';
      var grid = scope.querySelector('.product-grid');
      if (grid && grid.parentNode) grid.parentNode.appendChild(el);
      else (scope.querySelector('.collection-wrapper') || scope).appendChild(el);
    }
    return el;
  }

  function applyFilters(scope) {
    var st = state(scope);
    var q = st.q;
    var brands = st.brands;
    var items = scope.querySelectorAll('.product-grid__item');
    var shown = 0;
    items.forEach(function (item) {
      var okSearch = q === '' || haystack(item).indexOf(q) !== -1;
      var okBrand = brands.size === 0 || itemBrands(item).some(function (b) { return brands.has(b); });
      var vis = okSearch && okBrand;
      item.style.display = vis ? '' : 'none';
      if (vis) shown++;
    });

    var el = ensureEmptyEl(scope);
    el.textContent = st.empty;
    el.style.display = (shown === 0 && (q !== '' || brands.size > 0)) ? 'block' : 'none';

    // Sync active state on all brand buttons in this scope (sidebar + drawer)
    scope.querySelectorAll('[data-sk-brand]').forEach(function (btn) {
      var on = brands.has((btn.getAttribute('data-sk-brand') || '').toLowerCase());
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function bindSearch(wrap) {
    if (wrap.dataset.skBound) return;
    wrap.dataset.skBound = '1';
    var input = wrap.querySelector('.sk-filter-search__input');
    var btn = wrap.querySelector('[data-sk-search-btn]');
    if (!input) return;
    var scope = wrap.closest('.product-grid-container') || document;
    var st = state(scope);
    if (wrap.getAttribute('data-empty')) st.empty = wrap.getAttribute('data-empty');
    var timer = null;

    function run() { st.q = (input.value || '').trim().toLowerCase(); applyFilters(scope); }
    function schedule() { if (timer) clearTimeout(timer); timer = setTimeout(run, 120); }

    input.addEventListener('input', schedule);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    if (btn) btn.addEventListener('click', run);
  }

  function bindBrands(container) {
    if (container.dataset.skBound) return;
    container.dataset.skBound = '1';
    var scope = container.closest('.product-grid-container') || document;
    container.querySelectorAll('[data-sk-brand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var st = state(scope);
        var h = (btn.getAttribute('data-sk-brand') || '').toLowerCase();
        if (st.brands.has(h)) st.brands.delete(h); else st.brands.add(h);
        applyFilters(scope);
      });
    });
  }

  function bindToggle(tg) {
    if (tg.dataset.skBound) return;
    tg.dataset.skBound = '1';
    var scope = tg.closest('.product-grid-container') || document;
    var btns = tg.querySelectorAll('.sk-view-btn');
    function setView(view) {
      scope.classList.toggle('sk-view-list', view === 'list');
      scope.classList.toggle('sk-view-grid', view !== 'list');
      btns.forEach(function (b) {
        var on = b.getAttribute('data-sk-view') === view;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { setView(b.getAttribute('data-sk-view')); });
    });
    setView('grid'); // always default to grid
  }

  function init() {
    document.querySelectorAll('[data-sk-live-search]').forEach(bindSearch);
    document.querySelectorAll('[data-sk-brands-filter]').forEach(bindBrands);
    document.querySelectorAll('[data-sk-view-toggle]').forEach(bindToggle);
    document.querySelectorAll('.product-grid-container').forEach(function (scope) {
      if (scope.__sk) applyFilters(scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('collection:updated', init);
  document.addEventListener('search:updated', init);
})();